/* src/app/components/notification/notification-details/notification-details.component.scss */
/*# sourceMappingURL=notification-details.component.css.map */
